export default __webpack_public_path__ + "static/media/Edital 13.2023.SEDEC-SINE.e77d8de0.pdf";